import { RecentsController } from './pages/recents/recents.controller'
import { AllController } from './pages/all/all.controller'
import { OrganizedController } from './pages/organized/organized.controller'
import { UsedInController } from './pages/used-in/used-in.controller'
import { TrashController } from './pages/trash/trash.controller'
import { RepositoryController } from './repository.controller'
import { SharedController } from './pages/shared/shared.controller'
const getModule = () => import('./repository.module')

const lazyLoadModule = [
  '$q',
  '$ocLazyLoad',
  ($q, $ocLazyLoad) => {
    const deferred = $q.defer()
    getModule().then(({ repositoryModule }) => {
      $ocLazyLoad.load({
        name: repositoryModule.name
      })
      deferred.resolve(repositoryModule)
    })
    return deferred.promise
  }
]

const checkModuleEnabled = [
  '$q',
  '$state',
  '$rootScope',
  '$translate',
  'ToastService',
  ($q, $state, $rootScope, $translate, ToastService) => {
    const deferred = $q.defer()

    Promise.all([
      $rootScope.getUser()
    ]).then(([oUser]) => {
      if ($rootScope.isUser(oUser)) {
        deferred.reject()
      } else {
        deferred.resolve()
      }
    })

    return deferred.promise
      .catch(() => {
        ToastService.showErrorToast($translate.instant('repository.accessModuleValidation.userForbiddenToast'))

        $state.go('home')
      })
  }
]

/* @ngInject */
function routes ($stateProvider) {
  $stateProvider
    .state('repository', {
      url: '/repository',
      reloadOnSearch: false,
      views: {
        '': {
          templateUrl: '/repository/repository.html?$$REVISION$$',
          controller: RepositoryController
        },
        'secondLevelMenu@repository': {
          templateUrl: '/repository/repository-sidebar-menu.html?$$REVISION$$'
        }
      },
      resolve: {
        lazyLoadModule,
        checkModuleEnabled
      }
    })
    .state('repository.recents', {
      url: '/recents?view&previewId',
      reloadOnSearch: false,
      parent: 'repository',
      views: {
        'recents@repository': {
          templateUrl: '/repository/pages/recents/recents.html?$$REVISION$$',
          controller: RecentsController
        }
      },
      data: {
        selectedMenuId: 1
      },
      params: {
        view: 'grid'
      },
      resolve: {
        lazyLoadModule,
        checkModuleEnabled
      }
    })
    .state('repository.all', {
      url: '/all?view&previewId',
      reloadOnSearch: false,
      parent: 'repository',
      views: {
        'all@repository': {
          templateUrl: '/repository/pages/all/all.html?$$REVISION$$',
          controller: AllController
        }
      },
      data: {
        selectedMenuId: 2
      },
      params: {
        view: 'grid'
      },
      resolve: {
        lazyLoadModule,
        checkModuleEnabled
      }
    })
    .state('repository.organized', {
      url: '/organized?view&previewId&folderPreviewId',
      reloadOnSearch: false,
      parent: 'repository',
      views: {
        'organized@repository': {
          templateUrl: '/repository/pages/organized/organized.html?$$REVISION$$',
          controller: OrganizedController
        }
      },
      data: {
        selectedMenuId: 3
      },
      params: {
        view: 'grid'
      },
      resolve: {
        lazyLoadModule,
        checkModuleEnabled
      }
    })
    .state('repository.organizedFolder', {
      url: '/organized/folders/:id?view&previewId&folderPreviewId',
      reloadOnSearch: false,
      parent: 'repository',
      views: {
        'organized@repository': {
          templateUrl: '/repository/pages/organized/organized.html?$$REVISION$$',
          controller: OrganizedController
        }
      },
      data: {
        selectedMenuId: 3
      },
      params: {
        view: 'grid'
      },
      resolve: {
        lazyLoadModule,
        checkModuleEnabled
      }
    })
    .state('repository.used-in', {
      url: '/used-in/:usedInModule?view&previewId',
      reloadOnSearch: false,
      parent: 'repository',
      views: {
        'used-in@repository': {
          templateUrl: '/repository/pages/used-in/used-in.html?$$REVISION$$',
          controller: UsedInController
        }
      },
      data: {
        selectedMenuId: 4
      },
      params: {
        view: 'grid'
      },
      resolve: {
        lazyLoadModule,
        checkModuleEnabled
      }
    })
    .state('repository.trash', {
      url: '/trash?view&previewId',
      reloadOnSearch: false,
      parent: 'repository',
      views: {
        'trash@repository': {
          templateUrl: '/repository/pages/trash/trash.html?$$REVISION$$',
          controller: TrashController
        }
      },
      data: {
        selectedMenuId: 5
      },
      params: {
        view: 'grid'
      },
      resolve: {
        lazyLoadModule
      }
    })
    .state('repository.trashFolder', {
      url: '/trash/folders/:id?previewId?view',
      reloadOnSearch: false,
      parent: 'repository',
      views: {
        'trash@repository': {
          templateUrl: '/repository/pages/trash/trash.html?$$REVISION$$',
          controller: TrashController
        }
      },
      data: {
        selectedMenuId: 5
      },
      params: {
        view: 'grid'
      },
      resolve: {
        lazyLoadModule
      }
    })
    .state('repository.shared', {
      url: '/shared',
      reloadOnSearch: false,
      parent: 'repository',
      views: {
        'shared@repository': {
          templateUrl: '/repository/pages/shared/shared.html?$$REVISION$$',
          controller: SharedController
        }
      },
      data: {
        selectedMenuId: 6
      },
      params: {
        view: 'grid'
      },
      resolve: {
        lazyLoadModule,
        checkModuleEnabled
      }
    })
}

export const repositoryRoutes = routes
